export const isObjectEmpty = (obj) => !obj || !Object.keys(obj).length
